import { HistoryRow } from './historyModel';

/**
 * The eight rows of frame 67 (`6985:9381`), until a history API exists. The record ids are
 * placeholders: the design draws only the CFG references.
 */
export const HISTORY_FIXTURE: HistoryRow[] = [
  {
    reference: 'CFG-2291',
    recordId: 2291,
    name: 'Stamp Campaign for at-risk customers',
    type: 'campaign',
    status: 'draft',
    createdBy: 'Jane Doe',
    updatedAt: '2026-10-29T18:40:00+08:00'
  },
  {
    reference: 'CFG-2287',
    recordId: 2287,
    name: 'Shake the Tree — Festive Edition',
    type: 'campaign',
    status: 'live',
    createdBy: 'Jane Doe',
    updatedAt: '2026-10-27T13:40:00+08:00'
  },
  {
    reference: 'CFG-2284',
    recordId: 2284,
    name: 'Transaction Bonus Points Rule',
    type: 'rule',
    status: 'live',
    createdBy: 'Mark Lee',
    updatedAt: '2026-10-28T09:00:00+08:00'
  },
  {
    reference: 'CFG-2280',
    recordId: 2280,
    name: 'Jollibee P500 Voucher',
    type: 'reward',
    status: 'live',
    createdBy: 'Priya Sharma',
    updatedAt: '2026-10-30T12:30:00+08:00'
  },
  {
    reference: 'CFG-2276',
    recordId: 2276,
    name: '[Orbit]: Customers with low Health Signal',
    type: 'audience',
    status: 'live',
    createdBy: 'Jane Doe',
    updatedAt: '2026-10-21T10:05:00+08:00'
  },
  {
    reference: 'CFG-2271',
    recordId: 2271,
    name: 'Spin the Wheel — Q4 Push',
    type: 'campaign',
    status: 'in_review',
    createdBy: 'Mark Lee',
    updatedAt: '2026-10-24T16:12:00+08:00'
  },
  {
    reference: 'CFG-2268',
    recordId: 2268,
    name: 'Push Notification Rule for Instant Outcome',
    type: 'rule',
    status: 'live',
    createdBy: 'Priya Sharma',
    updatedAt: '2026-10-20T11:48:00+08:00'
  },
  {
    reference: 'CFG-2259',
    recordId: 2259,
    name: 'Loyalty Stamp Challenge',
    type: 'campaign',
    status: 'ended',
    createdBy: 'Jane Doe',
    updatedAt: '2026-10-01T09:00:00+08:00'
  }
];
